<template lang="pug">
.lk-ads(v-if="data" )
	.lk-ads__container
		v-loader(:loading="loading")
		component.lk-ads__title.h1(v-if="data && data.title" :is="data.titleLevel || 'h1'") {{data?.title}}
		.lk-ads__search
			.lk-ads__search-fields(v-if="data.fields" )
				template(v-for="(filter, index) in data.fields" :key="index")
					v-field.lk-ads__search-field(:field="filter" v-model="filter.value" @update:model-value="setDesiredId")
			.lk-ads__search-buttons(v-if="data.buttons" )
				button.lk-ads__search-button(v-for="(button, index) in data.buttons"
						:key="index"
						:class="button.className"
						:type="button.type"
						@click="submitId")
					| {{ button.text }}
		template(v-if="data.topFilters" )
			.lk-ads__tabs.tabs-nav-detail(v-for="(filter, index) in data.topFilters" :key="index")
				v-field(:field="filter" v-model="filter.value" @update:model-value="tabChange(filter, $event)")
			.lk-ads__content
			.lk-ads__filter-block
				.lk-ads__filter(v-if="data && data.filters")
					v-filter(ref="filter"
						:filters="data.filters"
						:variables="data.variables"
						@filter-changed="filterChanged"
						@filter-updated="filterUpdated"
						:withButton="false"
						)
				a.lk-ads__filter-btn.btn.btn--primary(v-if="data?.result?.href"
					:href="data?.result?.href") {{ data?.result?.text || 'Поиск' }}
					//-template(#sort="" v-if="data.sort")
					//-template(#view="" v-if="data.view")
			//.lk-ads__sort(v-if="state && state.sort")
			//	v-field.field-no-radio.field--row( v-if="!isXs"
			//		:field="{type: 'table-sort', options: state.sort.options, optionsClassNames: ['field-table-sort__item--big field-table-sort__item--left', 'field-table-sort__item--small', 'field-table-sort__item--small', 'field-table-sort__item--small']}"
			//		v-model="state.sort"
			//		@update:model-value="requestDataLoad"
			//		)
			//	v-field(v-if="isXs" :field="{type: 'select', options: state.sort.options, placeholder: state?.sort?.placeholder }" v-model="state.sort"
			//		@update:model-value="requestDataLoad"
			//	)
			template(v-if="data.variables?.empty")
				.lk-ads__empty {{ data.variables.empty }}
			template(v-else)
				.lk-ads__rows
					template(
						v-for="(item ,index) in data?.items"
						:key="index" )
						.lk-ads__row
							v-ads(:data-source="item"
								@action="handleClick"
							)
		.lk-ads__pagination(v-if="page && page.count > page.limit")
			v-page-nav(:page="page" :limits="limits" @navigate="navigate")

</template>

<script>
	import sourceMixin from '../components/mixins/v-mixin-source.vue';
	import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
	import controller from "../scripts/controller/controller.js";

	export default {
		mixins: [
			sourceMixin,
			isMobMixin
		],

		data() {
			return {
				data: null,
				page: null,
				desiredId: null,
				state: {
					filter: null,
				}
			}
		},

		methods: {

			dataSet(data) {
				this.data = data;
				this.page = data.page;
				this.limits = data.limits;

				if(this.data.modal) {
					controller.openModal({
						...this.data.modal,
					})
				}
				// this.state.sort = data.sort;
			},

			filterChanged(filterValue) {
				this.state.filter = filterValue;
				this.requestDataLoad();
			},


			filterUpdated(filterValue, changedFilters) {
				this.state.filter = filterValue;
				this.changedFilters = changedFilters;
				// update url except markup pages
				if (window.location.pathname.indexOf('/local/') < 0) {
					window.history.replaceState(null, null, this.catalog.remote);
				}
			},

			// sortChanged() {
			// 	this.state.page.offset = 0;
			// 	this.requestDataLoad();
			// },

			handleClick(event) {
				const {action = null, id = null} = event;

				if(!action) return;

				switch (action) {
					case 'make_it_paid' :
						this.reportForChange(action, id);
						break;
					case 'update' :
						this.reportForChange(action, id);
						break;
					case 'deactivate' :
						this.reportForChange(action, id);
						break;
					case 'activate' :
						this.reportForChange(action, id);
						break;
					case 'remove' :
						this.requestRemove(action, id);
						break;
				}
			},

			tabChange(filter, value) {
				this.state.filter = {...this.state.filter, [filter.name]: value}
				this.page.offset = 0;
				this.requestDataLoad();
			},

			setDesiredId(id) {
				this.desiredId = id
			},

			submitId() {
				if(this.desiredId) {
					this.dataLoad({
						url: this.data.remote,
						delay: true,
						data: {
							desiredId: this.desiredId
						}
					});
				}
			},

			reportForChange(action = null, id) {
				if(!action) return;
				this.dataLoad({
					url: this.data.remote,
					delay: true,
					data: {
						id,
						action
					}
				});
			},

			requestRemove(action = null, id) {
				if(this.data.modalConfirmRemove) {
					controller.openModal({
						component: {
							...this.data.modalConfirmRemove,
							listeners: {
								'confirm': async () => {
									this.reportForChange(action, id)
								},
							}
						}
					});
				} else {
					this.reportForChange(action, id)
				}
			},

			navigate(page) {
				this.page.offset = page.offset;
				this.page.limit = page.limit;
				this.requestDataLoad();
			},

			requestDataLoad() {
				this.dataLoad({
					url: this.data.remote,
					delay: true,
					data: {
						page: this.page,
						filter: this.state.filter,
						limits: this.limits.value
					}
				});
			},

		}

	}
</script>
